module.exports = __webpack_public_path__ + "static/media/all_question_detail_report.47ef1431.png";